import { supabase } from "./supabaseClient";

export function getSupabaseApiClient() {
  if (typeof supabase?.schema !== "function") {
    return supabase;
  }
  return supabase.schema("api");
}

export function apiFrom(name) {
  const client = getSupabaseApiClient();
  if (typeof client?.from === "function") {
    return client.from(name);
  }
  return supabase.from(name);
}

export function apiRpc(name, args) {
  const client = getSupabaseApiClient();
  if (typeof client?.rpc === "function") {
    return client.rpc(name, args);
  }
  return supabase.rpc(name, args);
}
